import { TextField, Button, Box, CircularProgress } from "@mui/material";
import { Save, Cancel } from "@mui/icons-material";
import { Vocabulary } from "../../Utils/Vocabulary";
import { EditExamDialogProps } from "../../Utils/Types";
import GenericModal from "../GenericModal";
import genericStyles from "../../Styles/genericStyles.module.css";

export default function EditExamDialog({
  open,
  exam,
  formData,
  saving,
  onClose,
  onSave,
  onFormDataChange,
}: EditExamDialogProps) {
  const actions = (
    <div className={genericStyles.modalActions}>
      <Button
        onClick={onClose}
        startIcon={<Cancel />}
        color="error"
        variant="outlined"
      >
        {Vocabulary.cancel}
      </Button>
      <Button
        onClick={onSave}
        variant="contained"
        startIcon={saving ? <CircularProgress size={16} /> : <Save />}
        disabled={saving}
        style={{ marginLeft: "8px" }}
      >
        {saving ? "Se salvează..." : Vocabulary.save}
      </Button>
    </div>
  );

  return (
    <GenericModal
      open={open}
      onClose={onClose}
      title={`Editează examen ${
        exam?.type === "teoretic" ? "teoretic" : "practic"
      }`}
      actions={actions}
    >
      <Box style={{ paddingTop: "16px" }}>
        <TextField
          label="Data și ora programată"
          type="datetime-local"
          value={formData.examDate}
          onChange={(e) => onFormDataChange("examDate", e.target.value)}
          fullWidth
          margin="normal"
          InputLabelProps={{ shrink: true }}
        />
      </Box>
    </GenericModal>
  );
}
